import { Button, type ButtonProps, CircularProgress } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { forwardRef } from 'react';

/** Minimum width for drawer/form footer buttons before flex-wrap kicks in. */
export const FOOTER_BUTTON_SX: SxProps<Theme> = { flex: 1, flexBasis: 200 };

export type SlabButtonProps = ButtonProps & {
  loading?: boolean;
};

export const SlabButton = forwardRef<HTMLButtonElement, SlabButtonProps>(
  ({ loading = false, disabled, children, ...rest }, ref) => (
    <Button ref={ref} disabled={disabled || loading} {...rest}>
      {loading ? <CircularProgress size={20} color='inherit' /> : children}
    </Button>
  ),
);
